var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSelectUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 15,
    r: 14.5,
    stroke: "#9A9AA7",
    strokeDasharray: "4 4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1334 11.2667C18.1334 13.0712 16.6705 14.5333 14.8672 14.5333C13.063 14.5333 11.6001 13.0712 11.6001 11.2667C11.6001 9.46214 13.063 8 14.8672 8C16.6705 8 18.1334 9.46214 18.1334 11.2667Z",
    stroke: "#9A9AA7",
    strokeWidth: 0.933333,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.8667 16.3999C17.2402 16.3927 19.2583 17.6946 20.0001 20.497C18.5049 21.5859 16.7449 22.0053 14.8667 21.9998C12.9885 22.0053 11.2286 21.5859 9.7334 20.497C10.476 17.6915 12.4907 16.3927 14.8667 16.3999Z",
    stroke: "#9A9AA7",
    strokeWidth: 0.933333,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSelectUser);
export default __webpack_public_path__ + "static/media/selectUser.068425355812f288d8c4493c6d9aef8f.svg";
export { ForwardRef as ReactComponent };